import {fromJS} from 'immutable';
import MAP_STYLE from './map-style-bspaint-dashboard.json';


// For more information on data-driven styles, see https://www.mapbox.com/help/gl-dds-ref/
export const linesLayer = fromJS({
  "id": "lines",
  "type": "line",
  "source": "lines",
  "paint": {
      "line-width" : ["get", "width"],
      "line-color" : ["get", "color"]
  },
  "interactive" : false
  })


export const defaultMapStyle = fromJS(MAP_STYLE);



// WEBPACK FOOTER //
// ./src/components/pages/Map/map-style.js